<template>
  <section class="fleet-kpi-section">
    <div class="section-header">
      <h2>Fleet KPI Section</h2>
      <span class="vessel-name">Vessel Name</span>
    </div>

    <div class="kpi-grid">
      <div
        v-for="kpi in kpis"
        :key="kpi.label"
        class="kpi-card"
        :class="`kpi-card--${kpi.status}`"
      >
        <span class="traffic-light" />
        <span class="kpi-label">{{ kpi.label }}</span>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "FleetKpiSection",

  data() {
    return {
      kpis: [
        { label: "Load Margin", status: "good" },
        { label: "Charter Party", status: "warning" },
        { label: "Propeller Margin", status: "critical" },
        { label: "Power Margin", status: "good" },
        { label: "Speed Loss / Power Increase", status: "warning" },
        { label: "SFOC Deviation", status: "critical" }
      ]
    };
  }
};
</script>

<style scoped>
.fleet-kpi-section {
  background: var(--color-bg);
  border: 1px solid var(--grid-line-color);
  border-radius: 16px;
  padding: 20px 24px;
  color: var(--color-text);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 18px;
}

.section-header h2 {
  margin: 0;
  color: var(--color-text);
  font-size: 22px;
  font-weight: 700;
}

.vessel-name {
  background: var(--color-primary);
  color: var(--color-bg);
  border-radius: 999px;
  padding: 6px 12px;
  font-size: 14px;
  font-weight: 600;
}

.kpi-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));
  gap: 12px;
}

.kpi-card {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 54px;
  border-radius: 12px;
  padding: 12px 14px;
  background: var(--color-primary-light);
  border: 1px solid var(--grid-line-color);
}

.traffic-light {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  flex-shrink: 0;
}

.kpi-card--good .traffic-light {
  background: #22c55e;
}

.kpi-card--warning .traffic-light {
  background: #f59e0b;
}

.kpi-card--critical .traffic-light {
  background: #ef4444;
}

.kpi-card--good {
  border-left: 5px solid #22c55e;
}

.kpi-card--warning {
  border-left: 5px solid #f59e0b;
}

.kpi-card--critical {
  border-left: 5px solid #ef4444;
}

.kpi-label {
  font-size: 15px;
  font-weight: 600;
  color: var(--color-text);
}
</style>
